import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=54c4a1e2&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=54c4a1e2&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c4a1e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54c4a1e2')) {
      api.createRecord('54c4a1e2', component.options)
    } else {
      api.reload('54c4a1e2', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=54c4a1e2&scoped=true&", function () {
      api.rerender('54c4a1e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ndmIV0VK7z4x/JS/comp/Paginate.vue"
export default component.exports